import { stepControlsContextObj, useFormField } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { EFormFieldsNames } from '../../types/requestForm';
import { TOPIC_ANSWERS } from '../../constants/requestForm/topicAnswers';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
import { LOGIN_ISSUE_TYPE_ANSWERS } from '../../constants/requestForm/loginIssueTypeAnswers';
import { ETopic } from '../../types/topic';
export function useFormTitle() {
  var _React$useContext = React.useContext(stepControlsContextObj),
    currentStep = _React$useContext.currentStep;
  var isSendFeedbackSucceed = useSelector(selectSendFeedbackSucceed);
  var _useFormField = useFormField({
      name: EFormFieldsNames.Topic
    }),
    value = _useFormField.field.value;
  var name = value === ETopic.Login ? EFormFieldsNames.LoginIssueType : EFormFieldsNames.Topic;
  var answers = value === ETopic.Login ? LOGIN_ISSUE_TYPE_ANSWERS : TOPIC_ANSWERS;
  var topicValue = useCurrentTopic(name, answers);
  if (isSendFeedbackSucceed) {
    return 'Получили ваше сообщение';
  }
  return currentStep.question.title || topicValue;
}
function useCurrentTopic(name, answers) {
  var _useFormField2 = useFormField({
      name: name
    }),
    value = _useFormField2.field.value;
  var topicAnswer = answers.find(function (answer) {
    return answer.value === value;
  });
  return (topicAnswer === null || topicAnswer === void 0 ? void 0 : topicAnswer.label) || '';
}